import { render, staticRenderFns } from "./PdDetailsSummary.vue?vue&type=template&id=72eaa1bf&scoped=true&"
import script from "./PdDetailsSummary.vue?vue&type=script&lang=js&"
export * from "./PdDetailsSummary.vue?vue&type=script&lang=js&"
import style0 from "./PdDetailsSummary.vue?vue&type=style&index=0&id=72eaa1bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eaa1bf",
  null
  
)

export default component.exports